import { productConcentrationSolventUnitTypeEnum } from "beitary-shared/src/types-schemas/common/units/ProductConcentrationSolventUnit/ProductConcentrationSolventUnit";
import { BSelect } from "components";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface ProductConcentrationSolventUnitSelectProps {
  required?: boolean;
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
  disabled?: boolean;
  readonly?: boolean;
}

export const ProductConcentrationSolventUnitSelect = (
  props: ProductConcentrationSolventUnitSelectProps
) => {
  const { t } = useTranslation();
  const data = productConcentrationSolventUnitTypeEnum.options.map((o) => ({
    value: o,
    label: t(o),
  }));

  return <BSelect {...props} data={data} nothingFound={t("NOTHING_FOUND")} />;
};
